<template>
  <form
    class="pthv-form pthvSchedule-form"
    method="post"
    @submit.prevent="$emit('nextDepartureClick', selectedData)"
  >
    <div>
      <select
        id="select-stop"
        class="form-select"
        v-model="selectedStop"
        :disabled="isLoading"
        @change="$emit('selectStop', selectedStop)"
        required
      >
        <option value="all">{{ $t("chooseStop") }}</option>
        <option
          v-for="stopRef in stopsRefs"
          v-bind:key="stopRef.refs.join('-')"
          v-bind:value="stopRef.refs"
        >
          <span v-text="htmlSpaces(stopRef.name)"></span>
        </option>
      </select>
    </div>

    <div class="schedule-select-stop-dates">
      <div class="griditem griditem-1">
        <label class="small-label" for="date">{{ $t("chooseDate") }}</label>
        <input
          type="date"
          id="date"
          name="date"
          v-model="selectedDate"
          :disabled="isLoading"
          :min="minDate"
          :max="maxDate"
          required
        />
      </div>

      <div class="griditem griditem-2">
        <label class="small-label" for="time">{{ $t("chooseTime") }}</label>
        <input
          type="time"
          id="time"
          name="time"
          v-model="selectedTime"
          :disabled="isLoading"
          required
        />
      </div>
    </div>

    <div v-if="selectedStop != 'all'">
      <button type="submit" :aria-controls="ariaControlItemId">
        {{ $t("nextTrips") }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: "ApthScheduleSelectStop",
  data() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let strToday = yyyy + "-" + mm + "-" + dd;
    let strNow =
      String(today.getHours()).padStart(2, "0") +
      ":" +
      String(today.getMinutes()).padStart(2, "0");

    return {
      selectedStop: "all",
      selectedDate: strToday,
      selectedTime: strNow,
    };
  },
  computed: {
    stopsRefs: function () {
      return this.parseStops(this.stops);
    },
    selectedData: function () {
      // let today = new Date();
      // let strNow = String(today.getHours()).padStart(2, '0') + ":" + String(today.getMinutes()).padStart(2, '0')+ ":00";
      // let time = strNow;
      // if (this.selectedTime){
      //   time = this.selectedTime + ":00"; // the expected return format is with seconds
      // }
      let data = {
        stop: this.selectedStop,
        date: this.selectedDate,
      };
      if (this.selectedTime) {
        data.time = this.selectedTime + ":00"; // the expected return format is with seconds
      }
      return data;
    },
  },
  props: {
    stops: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    ariaControlItemId: {
      type: String,
      required: false,
      default: null,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: true,
    },
    minDate: {
      type: String,
      required: false,
      default: null,
    },
    maxDate: {
      type: String,
      required: false,
      default: null,
    },
  },
  watch: {
    stopsRefs(newStopsRefs, oldStopsRefs) {
      // When list of stops refs is changing, set 'all' as default value
      this.selectedStop = "all";
    },
  },
  methods: {
    parseStops(stops) {
      let stopRefs = [];
      for (const stop of stops) {
        if (stop.StopName) {
          let label = stop.StopName.value;
          let name = label.toUpperCase();
          let refs = stopRefs[name] ? stopRefs[name].refs : []; // previous with same name
          /* refs = refs.concat(stop.spoints ? Object.keys(stop.spoints) : [stop.StopPointRef]); */
          refs = refs.concat([stop.StopPointRef]);
          refs = [...new Set(refs)]; // unique
          stopRefs[name] = { name: label, refs: refs };
        }
      }
      return Object.values(stopRefs);
    },
    htmlSpaces(txt) {
      // permet de préserver les successions d'espaces dans le select>options (PWE-491)
      txt = txt.replace(/ /g, "\u00a0");
      return txt;
    },
  },
};
</script>

<style lang="scss">
.schedule-select-stop-dates {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2rem;
  width: 100%;
  max-width: 100%;

  label {
    display: block;
  }
  input {
    width: 100%;
    box-sizing: border-box;
  }
}

.pthvSchedule-form {
  padding: 0.25rem;
}
</style>
